const nameOfSearch = {
  product: "Product",
  newsroom: "Article",
  global: "Global",
  event: "Event",
};

export default nameOfSearch;
